import styled from "styled-components"
import { mobile, mobilePortrait } from "../../Responsive"

export const Container = styled.div`
   width: auto;
   display: flex;
   position: relative;
   overflow: hidden;
   touch-action: pan-y;
`
export const Wrapper = styled.div`
   height: 100%;
   display: flex;
   transition: all 1.5s ease;
   transform: translateX(${(props) => props.slideIndex * -100}%);
`

export const Slide = styled.div`
   min-width: 100%;
   height: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
`

export const Image = styled.img`
   width: 100%;
   height: 80vh;
   object-fit: cover;
   border-radius: 20px;

   ${mobile({ height: "auto" })}
   ${mobilePortrait({ height: "40vh" })}
`

export const Video = styled.video`
   width: 100%;
   height: 80vh;
   object-fit: cover;
   border-radius: 20px;

   ${mobile({ height: "auto" })}
   ${mobilePortrait({ height: "40vh" })}
`

export const SlideBalls = styled.div`
   width: 100%;
   position: absolute;
   bottom: 20px;
   display: flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   z-index: 3;
`

export const SlideBall = styled.div`
   margin: 0 10px;
   height: 20px;
   width: 20px;
   border-radius: 50px;
   background-color: var(--${(props) => props.bgColor});

   :hover {
      opacity: 0.8;
   }
`

export const ImageFull = styled.img`
   position: fixed;
   top: 5%;
   left: 5%;
   width: 90%;
   height: 90%;
   z-index: 4;
   object-fit: cover;
   display: ${(props) => props.display};
   cursor: zoom-out;
`

export const VideoFull = styled.video`
   position: fixed;
   top: 5%;
   left: 5%;
   width: 90%;
   height: 90%;
   z-index: 4;
   object-fit: cover;
   display: ${(props) => props.display};
   cursor: zoom-out;
`
